import { useEffect, useRef } from "react";

const TWO_PI = Math.PI * 2;

const DEFAULT_IMAGES = [
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20single%20gold%20hoop%20earring%20alone%20laid%20flat%20on%20clean%20cream%20paper%20surface%20studio%20background%2C%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20model%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20diffused%20natural%20light%2C%20polished%20metal%20reflections%2C%20warm%20neutral%20palette%2C%20fine%20macro%20detail&width=800&height=1000&seq=earring-only-r1-01&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20sculptural%20silver%20drop%20earring%20with%20pearl%20accent%20alone%20on%20a%20clean%20warm%20beige%20studio%20surface%2C%20no%20person%20no%20model%20no%20ear%20no%20face%20no%20human%20no%20body%2C%20pure%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20diffused%20lighting%2C%20crisp%20metallic%20highlights%2C%20refined%20minimalist%20composition&width=800&height=1000&seq=earring-only-r1-02&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20macro%20product%20photograph%20of%20a%20geometric%20gold%20triangle%20statement%20earring%20laid%20alone%20on%20a%20soft%20cream%20studio%20background%2C%20no%20person%20no%20model%20no%20ear%20no%20face%20no%20human%20no%20body%2C%20pure%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20gentle%20directional%20lighting%2C%20polished%20surface%20reflections%2C%20warm%20neutral%20palette&width=800&height=1000&seq=earring-only-r1-03&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20dainty%20rose%20gold%20chain%20drop%20earring%20with%20small%20crystal%20detail%20alone%20on%20a%20clean%20soft%20ivory%20studio%20surface%2C%20no%20model%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20jewelry%20object%20only%20still%20life%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20natural%20lighting%2C%20delicate%20shadows%2C%20warm%20tones&width=800&height=1000&seq=earring-only-r1-04&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20macro%20still%20life%20of%20a%20vintage%20inspired%20emerald%20gemstone%20earring%20set%20in%20yellow%20gold%20placed%20alone%20on%20a%20clean%20warm%20taupe%20studio%20surface%2C%20no%20person%20no%20model%20no%20ear%20no%20face%20no%20human%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20studio%20lighting%2C%20crystal%20clarity%2C%20refined%20metal%20details&width=800&height=1000&seq=earring-only-r1-05&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20modern%20minimalist%20sterling%20silver%20bar%20earring%20alone%20on%20a%20clean%20light%20beige%20studio%20surface%2C%20no%20model%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20pure%20jewelry%20object%20only%2C%20ultra%20realistic%20contemporary%20catalog%20photography%2C%20soft%20diffused%20light%2C%20crisp%20reflections%2C%20architectural%20metallic%20design&width=800&height=1000&seq=earring-only-r1-06&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20macro%20product%20photograph%20of%20an%20intricate%20gold%20chandelier%20earring%20with%20cascading%20tiny%20crystals%20alone%20on%20a%20warm%20cream%20studio%20background%2C%20no%20person%20no%20model%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20glowing%20lighting%2C%20sparkling%20detail&width=800&height=1000&seq=earring-only-r1-07&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20freshwater%20pearl%20stud%20earring%20on%20yellow%20gold%20post%20alone%20on%20a%20soft%20ivory%20studio%20surface%2C%20no%20model%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20pure%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20natural%20lighting%2C%20subtle%20pearl%20luster%2C%20warm%20neutral%20aesthetic&width=800&height=1000&seq=earring-only-r1-08&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20macro%20still%20life%20of%20a%20sculptural%20organic%20shaped%20brass%20earring%20with%20hammered%20texture%20alone%20on%20a%20clean%20beige%20studio%20surface%2C%20no%20person%20no%20model%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20artisan%20catalog%20photography%2C%20soft%20directional%20lighting%2C%20warm%20metallic%20tones%2C%20refined%20handcrafted%20details&width=800&height=1000&seq=earring-only-r1-09&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20thin%20delicate%20gold%20threader%20earring%20with%20small%20sapphire%20accent%20alone%20on%20a%20clean%20warm%20cream%20studio%20surface%2C%20no%20model%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20fine%20jewelry%20catalog%20photography%2C%20soft%20diffused%20light%2C%20subtle%20gemstone%20sparkle&width=800&height=1000&seq=earring-only-r1-10&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20macro%20still%20life%20of%20a%20statement%20gold%20knot%20earring%20with%20polished%20smooth%20curves%20alone%20on%20a%20soft%20ivory%20studio%20surface%2C%20no%20person%20no%20model%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20pure%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20catalog%20photography%2C%20soft%20natural%20lighting%2C%20warm%20metallic%20reflections%2C%20sculptural%20design&width=800&height=1000&seq=earring-only-r1-11&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20pave%20diamond%20cluster%20earring%20in%20white%20gold%20alone%20on%20a%20clean%20light%20cream%20studio%20surface%2C%20no%20model%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20luxury%20fine%20jewelry%20catalog%20photography%2C%20soft%20studio%20lighting%2C%20brilliant%20diamond%20sparkle%2C%20warm%20neutral%20tones&width=800&height=1000&seq=earring-only-r1-12&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20macro%20still%20life%20of%20a%20boho%20style%20gold%20feather%20drop%20earring%20with%20turquoise%20bead%20laid%20alone%20on%20a%20warm%20beige%20studio%20surface%2C%20no%20person%20no%20model%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20pure%20jewelry%20object%20only%2C%20ultra%20realistic%20artisan%20catalog%20photography%2C%20soft%20warm%20lighting%2C%20detailed%20metal%20engraving%2C%20refined%20handcrafted%20aesthetic&width=800&height=1000&seq=earring-only-r1-13&orientation=portrait" },
  { src: "https://readdy.ai/api/search-image?query=Isolated%20product%20still%20life%20of%20a%20modern%20asymmetric%20gold%20earring%20design%20with%20small%20black%20onyx%20stone%20alone%20on%20a%20clean%20cream%20studio%20surface%2C%20no%20model%20no%20person%20no%20human%20no%20face%20no%20ear%20no%20body%2C%20jewelry%20object%20only%2C%20ultra%20realistic%20contemporary%20luxury%20catalog%20photography%2C%20soft%20diffused%20lighting%2C%20refined%20metallic%20details&width=800&height=1000&seq=earring-only-r1-14&orientation=portrait" },
];

interface SpiralImagesProps {
  images?: { src: string }[];
  turns?: number;
  speed?: number;
  spacing?: number;
  spread?: number;
  sizeAttenuation?: number;
  imageSize?: number;
  fadeIn?: number;
  fadeOut?: number;
  cornerRadius?: number;
  className?: string;
}

export default function SpiralImages({
  images = DEFAULT_IMAGES,
  turns = 4,
  speed = 1,
  spacing = 3,
  spread = 10,
  sizeAttenuation = 2,
  imageSize = 173,
  fadeIn = 20,
  fadeOut = 20,
  cornerRadius = 20,
  className = "",
}: SpiralImagesProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const rafRef = useRef(0);
  const progressRef = useRef(0);
  const lastRef = useRef(0);
  const imgsRef = useRef<(HTMLImageElement | null)[]>([]);
  const draggingRef = useRef(false);
  const dragStartRef = useRef({ x: 0, y: 0 });
  const dragDeltaRef = useRef(0);

  const items = images.length > 0 ? images : DEFAULT_IMAGES;
  const srcKey = items.map((im) => im?.src || "").join("|");

  useEffect(() => {
    imgsRef.current = items.map((im) => {
      if (!im?.src) return null;
      const el = new Image();
      el.crossOrigin = "anonymous";
      el.src = im.src;
      return el;
    });
  }, [srcKey]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const dpr = Math.min(2, typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1);
    let w = 0;
    let h = 0;

    const resize = () => {
      w = container.clientWidth || 600;
      h = container.clientHeight || 600;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
    };
    resize();
    const ro = new ResizeObserver(resize);
    ro.observe(container);

    const onPointerDown = (e: PointerEvent) => {
      draggingRef.current = true;
      dragStartRef.current = { x: e.clientX, y: e.clientY };
      dragDeltaRef.current = 0;
      container.setPointerCapture?.(e.pointerId);
      container.style.cursor = "grabbing";
    };
    const onPointerMove = (e: PointerEvent) => {
      if (!draggingRef.current) return;
      const dx = e.clientX - dragStartRef.current.x;
      const dy = e.clientY - dragStartRef.current.y;
      // Combined drag magnitude, sign follows horizontal drag direction.
      const mag = Math.sqrt(dx * dx + dy * dy);
      const sign = dx + dy >= 0 ? 1 : -1;
      dragDeltaRef.current = sign * mag;
    };
    const endDrag = (e: PointerEvent) => {
      if (!draggingRef.current) return;
      draggingRef.current = false;
      dragDeltaRef.current = 0;
      container.releasePointerCapture?.(e.pointerId);
      container.style.cursor = "grab";
    };

    container.style.cursor = "grab";
    container.addEventListener("pointerdown", onPointerDown);
    container.addEventListener("pointermove", onPointerMove);
    container.addEventListener("pointerup", endDrag);
    container.addEventListener("pointercancel", endDrag);
    container.addEventListener("pointerleave", endDrag);

    const spiral = (n: number, R: number) => {
      const ang = n * turns * TWO_PI;
      const rad = R * (1 - n);
      return { x: rad * Math.cos(ang), y: -rad * Math.sin(ang) };
    };

    const M = 2000;
    const cum = new Float32Array(M + 1);
    let prev = spiral(0, 1);
    for (let k = 1; k <= M; k++) {
      const pt = spiral(k / M, 1);
      const dx = pt.x - prev.x;
      const dy = pt.y - prev.y;
      cum[k] = cum[k - 1] + Math.sqrt(dx * dx + dy * dy);
      prev = pt;
    }
    const total = cum[M] || 1;
    const K = 1024;
    const nForArc = new Float32Array(K + 1);
    let j = 0;
    for (let a = 0; a <= K; a++) {
      const target = (a / K) * total;
      while (j < M && cum[j + 1] < target) j++;
      const seg = cum[j + 1] - cum[j];
      const f2 = seg > 0 ? (target - cum[j]) / seg : 0;
      nForArc[a] = (j + f2) / M;
    }
    const arcToN = (s: number) => {
      const x = Math.max(0, Math.min(K, s * K));
      const i = Math.floor(x);
      const a = nForArc[i];
      const b = nForArc[Math.min(i + 1, K)];
      return a + (b - a) * (x - i);
    };

    const roundRect = (
      c: CanvasRenderingContext2D,
      x: number,
      y: number,
      rw: number,
      rh: number,
      r: number
    ) => {
      const rr = Math.min(r, rw / 2, rh / 2);
      c.beginPath();
      c.moveTo(x + rr, y);
      c.arcTo(x + rw, y, x + rw, y + rh, rr);
      c.arcTo(x + rw, y + rh, x, y + rh, rr);
      c.arcTo(x, y + rh, x, y, rr);
      c.arcTo(x, y, x + rw, y, rr);
      c.closePath();
    };

    const draw = (now: number) => {
      const dt = lastRef.current ? (now - lastRef.current) / 1000 : 0;
      lastRef.current = now;
      const f = Math.min(dt, 0.1);

      // While dragging: reverse direction AND boost speed based on drag distance.
      let effectiveSpeed = speed;
      if (draggingRef.current) {
        const boost = Math.min(6, Math.abs(dragDeltaRef.current) / 40);
        effectiveSpeed = -speed * (2 + boost);
      }

      progressRef.current = (progressRef.current + effectiveSpeed * f) % 100;
      if (progressRef.current < 0) progressRef.current += 100;
      const L = progressRef.current;

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);

      const cx = w / 2;
      const cy = h / 2;
      const R = 0.48 * Math.min(w, h) * (1 + (spread - 1) * 0.18);
      const els = imgsRef.current;
      const nImgs = els.length || 1;

      const stepFrac = Math.max(0.005, (spacing * 0.5) / 100);
      const slots = Math.min(400, Math.ceil(1 / stepFrac) + 2);
      const base = L / 100;

      const cards: { tt: number; n: number; img: number }[] = [];
      for (let i = 0; i < slots; i++) {
        const s = (((base + i * stepFrac) % 1) + 1) % 1;
        const n = arcToN(s);
        cards.push({ tt: s * 100, n, img: i % nImgs });
      }
      cards.sort((a, b) => a.n - b.n);

      for (let k = 0; k < cards.length; k++) {
        const { tt, n, img: imgIdx } = cards[k];
        const p = spiral(n, R);
        const dist = Math.sqrt(p.x * p.x + p.y * p.y);

        let opacity = 1;
        if (tt < fadeIn) opacity = tt / fadeIn;
        else if (tt > 100 - fadeOut) opacity = (100 - tt) / fadeOut;
        if (opacity < 0.01) continue;

        const scale =
          sizeAttenuation > 0
            ? Math.pow(Math.min(dist / R, 1), sizeAttenuation * 0.5)
            : 1;

        const p2 = spiral(Math.min(n + 0.001, 1), R);
        const angle = Math.atan2(p2.y - p.y, p2.x - p.x);

        const el = els[imgIdx];
        const ready = el && el.complete && el.naturalWidth > 0;
        // Force square cards so the clip becomes a perfect circle.
        const size = imageSize * scale;
        const cw = size;
        const ch = size;

        const x = cx + p.x;
        const y = cy + p.y;
        const rad = size / 2; // full circle

        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.globalAlpha = opacity;
        roundRect(ctx, -cw / 2, -ch / 2, cw, ch, rad);
        ctx.clip();
        if (ready) {
          // Cover-fit the source image into the square card (center crop).
          const iw = el!.naturalWidth;
          const ih = el!.naturalHeight;
          const srcAspect = iw / ih;
          let sx = 0;
          let sy = 0;
          let sw = iw;
          let sh = ih;
          if (srcAspect > 1) {
            // wider than tall — crop sides
            sw = ih;
            sx = (iw - sw) / 2;
          } else if (srcAspect < 1) {
            // taller than wide — crop top/bottom
            sh = iw;
            sy = (ih - sh) / 2;
          }
          ctx.drawImage(el!, sx, sy, sw, sh, -cw / 2, -ch / 2, cw, ch);
        } else {
          ctx.fillStyle = `hsl(${(imgIdx * 360) / nImgs}, 65%, 55%)`;
          ctx.fillRect(-cw / 2, -ch / 2, cw, ch);
        }
        ctx.restore();
      }

      rafRef.current = requestAnimationFrame(draw);
    };

    lastRef.current = 0;
    rafRef.current = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(rafRef.current);
      ro.disconnect();
      container.removeEventListener("pointerdown", onPointerDown);
      container.removeEventListener("pointermove", onPointerMove);
      container.removeEventListener("pointerup", endDrag);
      container.removeEventListener("pointercancel", endDrag);
      container.removeEventListener("pointerleave", endDrag);
    };
  }, [srcKey, turns, speed, spacing, spread, sizeAttenuation, imageSize, fadeIn, fadeOut, cornerRadius]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <canvas ref={canvasRef} style={{ display: "block" }} />
    </div>
  );
}